import { render, staticRenderFns } from "./SendSmsCode.vue?vue&type=template&id=bcd46ce0&scoped=true&"
import script from "./SendSmsCode.vue?vue&type=script&lang=js&"
export * from "./SendSmsCode.vue?vue&type=script&lang=js&"
import style0 from "./SendSmsCode.vue?vue&type=style&index=0&id=bcd46ce0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd46ce0",
  null
  
)

export default component.exports